import { useMemo } from "react"

import { format } from "date-fns"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useIsMobileDevice, Typography } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { EQUIPMENT_CONDITIONS_VALUES } from "../../constants/equipmentConditions"

import * as Styled from "./EquipmentDetails.styled"

export function EquipmentDetails(props) {

    const { equipment } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const isMobile = useIsMobileDevice()

    const tagsChips = useMemo(() => {
        return (equipment.tags || []).map(tag => ({ label: tag }))
    }, [equipment])

    const updatedInfo = useMemo(() => {
        if (!equipment.updated_at) {
            return null
        }

        const date = format(new Date(equipment.updated_at), "dd/MM/yyyy")
        const user = equipment.updated_by ?? "Logiroad"
        return <Typography variant="caption">
            {
                t(I18N_NAMESPACE, "containers.equipmentDetail.updateInfo", {
                    date,
                    user,
                })
            }
        </Typography>
    }, [equipment, t])

    return <Styled.Container isMobile={isMobile}>
        <Styled.TitleHeader>
            <Typography variant="H3">{t(I18N_NAMESPACE, "containers.equipmentDetail.title")}</Typography>
        </Styled.TitleHeader>
        <Styled.TextWrapper>
            <Styled.Text isMobile={isMobile}>
                {t(I18N_NAMESPACE, "containers.equipmentDetail.condition.label")}&nbsp;
            </Styled.Text>
            <Styled.StateWrapper
                color={EQUIPMENT_CONDITIONS_VALUES[equipment.condition].backgroundColor}
                isMobile={isMobile}
            >
                <Styled.State
                    color={EQUIPMENT_CONDITIONS_VALUES[equipment.condition].color}
                    variant="H3"
                >
                    {t(I18N_NAMESPACE, EQUIPMENT_CONDITIONS_VALUES[equipment.condition].label)}
                </Styled.State>
            </Styled.StateWrapper>
        </Styled.TextWrapper>
        {
            equipment?.content && <Styled.TextWrapper>
                <Styled.Text isMobile={isMobile}>
                    {t(I18N_NAMESPACE, "containers.equipmentDetail.panelText.label")}&nbsp;
                </Styled.Text>
                <Styled.ContentText
                    color={equipment.content ? "colors/gris/1000" : "texts/text-placeholder"}
                    isMobile={isMobile}
                >
                    {equipment.content || t(I18N_NAMESPACE, "containers.equipmentDetail.panelText.text")}
                </Styled.ContentText>
            </Styled.TextWrapper>
        }
        <Styled.TextWrapper>
            <Styled.Text isMobile={isMobile}>
                {t(I18N_NAMESPACE, "containers.equipmentDetail.tags")}&nbsp;
            </Styled.Text>
            {tagsChips.length ? <Styled.ChipList isMobile={isMobile} values={tagsChips} />
                : <Styled.ContentText color={"texts/text-placeholder"} isMobile={isMobile}>-</Styled.ContentText>}
        </Styled.TextWrapper>
        {updatedInfo}
    </Styled.Container>
}

EquipmentDetails.propTypes = {
    equipment: PropTypes.equipment.isRequired,
}